import { type ReactNode } from 'react';
import {
  type ISubmissionMenuItem,
  SubmissionMenuItemType,
} from '../menu/ISubmissionMenuItem.tsx';
import {
  type IGetSubmissionMenuLink,
  type IGetSubmissionMenuLinkParams,
} from './getSubmissionMenuItemLink.ts';
import { SubmissionMenuKey } from './SubmissionMenuKey.ts';

export interface IBuildReportMenuItemParams {
  submissionId: string;
  getMenuLink: IGetSubmissionMenuLink;
  /** Etichetta della voce di menu (Frontoffice e Backoffice passano la propria). */
  name: string;
  /** Icona della voce di menu (Frontoffice e Backoffice passano la propria). */
  icon?: ReactNode;
  options?: IGetSubmissionMenuLinkParams['options'];
}

/**
 * Costruisce la voce di menu "Riepilogo della Richiesta".
 *
 * L'hook condiviso `useSubmissionMenuItems` non emette questa voce quando la
 * richiesta è inviata (o quando `hideReport` è attivo): va quindi aggiunta in
 * testa a mano dai consumer (Backoffice e vista Frontoffice "inviata"), che
 * mantengono ognuno il proprio chiamante dedicato (etichetta, icona e link
 * propri).
 */
export function buildReportMenuItem(
  params: IBuildReportMenuItemParams,
): ISubmissionMenuItem {
  const { submissionId, getMenuLink, name, icon, options } = params;
  return {
    key: SubmissionMenuKey.Report,
    index: SubmissionMenuKey.Report,
    name,
    type: SubmissionMenuItemType.Send,
    icon,
    to: getMenuLink({ submissionId, type: 'report', options }),
  };
}
